import fpti from '@paypalcorp/fpti'
// eslint-disable-next-line import/no-cycle
import { getPgrp } from './get-pgrp.js'
import { application } from '../constants'
/**
 * Records impression event for FPTI.
 * @param {Object} fptiData server-side or additional properties to track
 */
export function recordFptiImpression(fptiData) {
  const options = { ...fptiData } || {}

  // differentiate between ddnw and dnw
  const pathList = window.location.pathname.replace(/(^\/|\/$)/g, '').split('/')
  const component =
    pathList.length > 1 && pathList[0] === 'dashboard'
      ? 'devdashnodeweb'
      : 'devdiscoverynodeweb'

  // ddnw configurations
  const path = getPgrp(pathList)
  const pgrp =
    path[path.length - 1] === 'sandbox' || path[path.length - 1] === 'live'
      ? path.slice(0, -1).join(':')
      : path.join(':')
  const page = path.join(':')

  // modify FPTI data
  options.pgrp = pgrp
  options.page = page
  options.comp = component
  options.env = application.env
  options.e = 'im'
  options.event_name = 'devexp_impression'

  if (window.fpti) {
    window.fpti.page = page
    window.fpti.pgrp = pgrp
    if (
      path[path.length - 1] === 'sandbox' ||
      path[path.length - 1] === 'live'
    ) {
      window.fpti.optsel = path[path.length - 1]
      options.optsel = path[path.length - 1]
    } else {
      window.fpti.optsel = null
    }
  }

  fpti.recordImpression(options)
}
